export default "__VITE_ASSET__CxmxZmPD__"